{
  "Dashboard": "Painel",
  "BlyCareShippingProte": "Proteção de envio BlyCare",
  "LoadingBlyCare": "A carregar o BlyCare…",
  "LoadingWidgetSetting": "A carregar as definições do widget…",
  "PreparingYourWorkspa": "A preparar o seu espaço de trabalho",
  "Language": "Idioma",
  "English": "English",
  "EnglishDefault": "English (predefinido)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "Guia de configuração",
  "CompletedOfTotalComp": "{{completed}} de {{total}} concluídos",
  "Dismiss": "Dispensar",
  "MoreActions": "Mais ações",
  "ToggleSetupGuide": "Mostrar ou ocultar o guia de configuração",
  "ActivateAppEmbed": "Ativar app embed",
  "ClickTheEnableButton": "1. Clique no botão Ativar abaixo para abrir o editor de temas do Shopify.",
  "BlyCareEmbedSection": "2. Procure BlyCare na secção App embed à esquerda. Certifique-se de que o respetivo interruptor está ativado. Em seguida, clique em Guardar no canto superior direito.",
  "Enable": "Ativar",
  "PublishWidget": "Publicar widget",
  "PublishStorefront": "Publique o widget na sua loja online para que os clientes possam comprá-lo.",
  "Publish": "Publicar",
  "SetProtectionFee": "Definir a taxa de proteção",
  "FeeYouWantToCharge": "Defina a taxa que pretende cobrar aos clientes.",
  "Setup": "Configurar",
  "TestYourWidgetOnYour": "Teste o widget na sua loja",
  "AddAProductToYourCar": "Adicione um produto ao carrinho e verifique se o widget de proteção de envio aparece. Selecione a proteção de envio, avance para a finalização da compra e certifique-se de que o produto de proteção de envio está incluído na página de finalização da compra.",
  "TestNow": "Testar agora",
  "Working": "Tudo a funcionar",
  "NeedHelp": "Precisa de ajuda?",
  "MarkAsCompleted": "Marcar como concluído",
  "AppStatus": "Estado da aplicação",
  "AppEmbed": "App embed",
  "EnableAppEmbedToDisp": "Ative o app embed para mostrar a proteção de envio no carrinho.",
  "CartPage": "Mostrar a proteção de envio na página do carrinho.",
  "CheckoutBlock": "Bloco de finalização da compra",
  "CheckoutPage": "Mostrar a proteção de envio na página de finalização da compra.",
  "Active": "Ativo",
  "Inactive": "Inativo",
  "Analytics": "Análises",
  "Today": "Hoje",
  "Last7Days": "Últimos 7 dias",
  "Last30Days": "Últimos 30 dias",
  "Last60Days": "Últimos 60 dias",
  "Last90Days": "Últimos 90 dias",
  "Last365Days": "Últimos 365 dias",
  "Custom": "Personalizado",
  "Start": "Início",
  "End": "Fim",
  "DateRange": "Intervalo de datas",
  "SelectedRange": "Intervalo selecionado: {{range}}",
  "Cancel": "Cancelar",
  "Save": "Guardar",
  "ChooseAStartDateOnOr": "Escolha uma data de início igual ou anterior à data de fim e não selecione um dia posterior a hoje.",
  "PreviousMonth": "Mês anterior",
  "NextMonth": "Mês seguinte",
  "ProtectionRevenue": "Receita de proteção",
  "ProtectedOrders": "Encomendas protegidas",
  "ProtectedOrderRate": "Taxa de encomendas protegidas",
  "LoadingAnalytics": "A carregar análises…",
  "AnalyticsCouldNotLo": "Não foi possível carregar as análises",
  "RetryAnalytics": "Tentar novamente as análises",
  "Resources": "Recursos",
  "HowDoesShippingProte": "Como funciona a proteção de envio?",
  "BlyCareAddsAShipping": "O BlyCare adiciona um widget de proteção de envio ao carrinho. Os clientes podem optar por adicionar proteção às suas encomendas. O comerciante cobra a taxa de proteção, decide que situações estão cobertas e utiliza essas taxas para resolver reclamações.",
  "DoesBlyCareCoverInsu": "O BlyCare cobre sinistros de seguro?",
  "NoBlyCareIsNotInsura": "Não. O BlyCare não é um seguro e não paga sinistros. O BlyCare apenas fornece o widget e as ferramentas para os comerciantes gerirem o seu próprio programa de proteção de envio.",
  "EmailUs": "Envie-nos um e-mail",
  "LiveChat": "Chat ao vivo",
  "HelpCenter": "Centro de ajuda",
  "Settings": "Definições",
  "CheckoutWidget": "Widget de finalização da compra",
  "CartWidget": "Widget do carrinho",
  "PriceSetting": "Definição de preço",
  "ProductSetting": "Definição de produto",
  "AdminLanguage": "Idioma do administrador",
  "AdminLanguageTitle": "Idioma do administrador",
  "AdminLanguageHelp": "Altera o idioma da aplicação apenas para si. Os clientes não são afetados.",
  "AppLanguage": "Idioma da aplicação",
  "UnableToLoadSettings": "Não foi possível carregar as definições",
  "TryAgain": "Tentar novamente",
  "Discard": "Descartar",
  "LoadingSettings": "A carregar as definições",
  "PageNotFound": "Página não encontrada",
  "ProductSettingsCould": "Não foi possível guardar as definições do produto.",
  "Fulfillment": "Processamento",
  "FulfillmentHelp": "Escolha quando o produto de proteção é marcado como processado.",
  "ManuallyFulfill": "Processar manualmente",
  "MarkFulfilledWhenFir": "Marcar como processado quando o primeiro artigo da encomenda for processado",
  "MarkFulfilledWhenAll": "Marcar como processado quando todos os outros artigos da encomenda forem processados",
  "MarkFulfilledImmedi": "Marcar como processado imediatamente após a criação da encomenda",
  "Exclusions": "Exclusões",
  "ExclusionsHelp": "Escolha quando a proteção não deve ser aplicada.",
  "ExclusionType": "Tipo de exclusão",
  "Select": "Selecionar",
  "SelectedExclusions": "Exclusões selecionadas",
  "RemoveName": "Remover {{name}}",
  "WhenExcluded": "Quando excluído",
  "HideWidget": "Ocultar widget",
  "KeepWidgetButSkipThe": "Manter o widget mas não cobrar a taxa",
  "ExcludeProductType": "Excluir tipo de produto",
  "SearchProductType": "Pesquisar tipo de produto",
  "ExcludeSKU": "Excluir SKU",
  "SearchSKU": "Pesquisar SKU",
  "ExcludeCollection": "Excluir coleção",
  "SearchCollection": "Pesquisar coleção",
  "ExcludeMarket": "Excluir mercado",
  "SearchMarket": "Pesquisar mercado",
  "ExcludeLanguage": "Excluir idioma",
  "SearchLanguage": "Pesquisar idioma",
  "Add": "Adicionar",
  "PriceSettingsCouldNo": "Não foi possível guardar as definições de preços.",
  "ShippingProtectionPr": "Preço da proteção de envio",
  "SetHowMuchPriceDoYou": "Defina quanto cobrar ao cliente",
  "PricingMethod": "Método de preço",
  "Fixed": "Fixo",
  "Percentage": "Percentagem",
  "UniversalProtectionP": "Preço de proteção universal",
  "PercentageOfCartSubt": "Percentagem do subtotal do carrinho",
  "EditCappedPrice": "Editar preço máximo",
  "ShippingProtectionFe": "Taxa de proteção de envio por percentagem a partir de {{minPrice}} USD, com aumentos de {{increment}} USD, até um máximo de {{capped}} USD.",
  "MinProtectionFee": "Taxa de proteção mínima",
  "IncrementAmount": "Montante do aumento",
  "CappedProtectionFee": "Taxa de proteção máxima",
  "AddTierPrice": "Adicionar preço escalonado",
  "AddTier": "Adicionar escalão",
  "TierPriceHelp": "Se o preço do carrinho não corresponder a nenhum dos intervalos de preços escalonados, será aplicado o preço universal definido na página anterior.",
  "MinCartPrice": "Preço mínimo do carrinho",
  "MaxCartPrice": "Preço máximo do carrinho",
  "ProtectionFee": "Taxa de proteção",
  "RemoveTier": "Remover escalão",
  "Required": "Obrigatório",
  "ThisFieldIsRequired": "Este campo é obrigatório.",
  "MustBeGreaterThanZero": "{{label}} deve ser superior a 0.",
  "MustBeOrLess": "{{label}} deve ser {{max}} ou inferior.",
  "AtMostTwoDecimals": "{{label}} pode ter no máximo 2 casas decimais.",
  "MustBeLargerThanMinC": "Deve ser superior ao preço mínimo do carrinho",
  "MustBeLargerThanMaxC": "Deve ser superior ao preço máximo do carrinho",
  "MustBeSmallerThanMin": "Deve ser inferior ao preço mínimo do carrinho",
  "Price": "Preço",
  "MinimumPrice": "Preço mínimo",
  "Increment": "Aumento",
  "CartPageWidget": "Widget da página do carrinho",
  "CheckoutPageWidget": "Widget da página de finalização da compra",
  "WidgetFormat": "Formato do widget",
  "TickerWidget": "Widget padrão",
  "CheckoutButtonWidget": "Widget de botão de finalização da compra",
  "Text": "Texto",
  "MainText": "Texto principal",
  "Title": "Título",
  "Description": "Descrição",
  "MainButtonText": "Texto do botão principal",
  "SecondaryButtonText": "Texto do botão secundário",
  "EnabledDescription": "Descrição ativada",
  "DisabledDescription": "Descrição desativada",
  "PleaseEnterTitle": "Introduza o título",
  "PleaseEnterDescript": "Introduza a descrição",
  "PleaseEnterMainButt": "Introduza o texto do botão principal",
  "PleaseEnterSecondar": "Introduza o texto do botão secundário",
  "PleaseEnterEnabledD": "Introduza a descrição ativada",
  "PleaseEnterDisabled": "Introduza a descrição desativada",
  "EGViewTerms": "ex.: Ver termos",
  "EGHttpTerms": "ex.: https://terms.com",
  "Footer": "Rodapé",
  "FooterText": "Texto do rodapé",
  "FooterLink": "Ligação do rodapé",
  "TooltipLink": "Ligação do tooltip",
  "FooterVisibility": "Visibilidade do rodapé",
  "TitleInfoVisibility": "Visibilidade das informações do título",
  "Disabled": "Desativado",
  "Enabled": "Ativado",
  "Color": "Cor",
  "ColorStyle": "Estilo de cor",
  "SizeAndDisplay": "Tamanho e visualização",
  "IconSize": "Tamanho do ícone",
  "IconRadius": "Raio do ícone",
  "BorderSize": "Tamanho da borda",
  "BorderRadius": "Raio da borda",
  "HorizontalPadding": "Preenchimento horizontal",
  "VerticalPadding": "Preenchimento vertical",
  "ToggleFormat": "Formato do interruptor",
  "Switch": "Interruptor",
  "Checkbox": "Caixa de seleção",
  "Border": "Borda",
  "Background": "Fundo",
  "ProtectionDescript": "Descrição da proteção",
  "MainButtonBackgrou": "Fundo do botão principal",
  "EnabledToggle": "Interruptor ativado",
  "DisabledToggle": "Interruptor desativado",
  "Automatic": "Automático",
  "Neutral": "Neutro",
  "Info": "Informação",
  "Success": "Sucesso",
  "Warning": "Aviso",
  "Critical": "Crítico",
  "Subdued": "Atenuado",
  "Transparent": "Transparente",
  "ThemeColor": "Cor do tema",
  "ResetToDefaultColor": "{{label}}: repor a cor predefinida",
  "OpenColorPicker": "{{label}}: abrir seletor de cor",
  "Icon": "Ícone",
  "PackageIcon": "Ícone de encomenda",
  "PackageIconNumber": "Ícone de encomenda {{value}}",
  "UploadIcon": "Carregar ícone",
  "NoIcon": "Sem ícone",
  "AcceptedFormats": "Formatos aceites: PNG, JPG, SVG",
  "MaximumFileSize": "Tamanho máximo do ficheiro: 50 MB",
  "AddFiles": "Adicionar ficheiros",
  "RemoveImage": "Remover imagem",
  "Uploading": "A carregar",
  "UploadFailedTryAgain": "O carregamento falhou. Tente novamente.",
  "ChooseAJPEGPNG": "Escolha uma imagem JPEG, PNG ou SVG até 50 MB.",
  "ChooseNonemptyImage": "Escolha uma imagem JPEG, JPG, PNG ou SVG não vazia até 50 MB.",
  "ImageCouldNotBeRead": "Não foi possível ler a imagem.",
  "FileContentsMismatch": "O conteúdo do ficheiro deve corresponder ao respetivo tipo de imagem JPEG, PNG ou SVG.",
  "ImageCouldNotBeDecode": "Não foi possível descodificar a imagem.",
  "InvalidImageUrl": "O serviço de carregamento devolveu um URL de imagem inválido.",
  "MissingPublicImageUrl": "O serviço de carregamento não devolveu um URL de imagem público.",
  "CustomCssTooLong": "O CSS personalizado pode ter no máximo 2 000 caracteres.",
  "ChooseValidIconUrl": "Escolha um ícone carregado com um URL válido.",
  "EnterNumberRange": "Introduza um número de {{min}} a {{max}}.",
  "EnterLocaleTextRange": "Introduza o texto de {{locale}} entre 1 e {{limit}} caracteres.",
  "EnterValidLearnMoreUrl": "Introduza um URL válido de Saiba mais que comece por https:// ou http://.",
  "ReviewHighlightedFields": "Reveja os campos realçados.",
  "CannotChangePublishState": "Não é possível alterar o estado de publicação até o formulário ser válido: {{reason}}",
  "BlyCareCouldNotSave": "O BlyCare não conseguiu guardar.",
  "CheckoutRequiresPlus": "A personalização da finalização da compra requer o Shopify Plus.",
  "SaveSucceededReloadFailed": "O pedido de gravação foi bem-sucedido, mas não foi possível carregar as definições mais recentes do widget. Atualize para confirmar as alterações.",
  "BlyCareCouldNotComplete": "O BlyCare não conseguiu concluir este pedido.",
  "ShopifyAuthorizationRequired": "É necessária a autorização do Shopify.",
  "AppBridgeUnavailable": "O Shopify App Bridge não está disponível",
  "ExtensionStatusUnavailable": "O estado da extensão do Shopify não está disponível.",
  "ConfigurationPreview": "Pré-visualização da configuração",
  "On": "Ativado",
  "Off": "Desativado",
  "Unpublish": "Anular publicação",
  "AppEmbedIsNotEnable": "O app embed não está ativado.",
  "GoEnabled": "Ir para Ativar",
  "ViewOnYourStorefront": "Ver na sua loja online",
  "PreviewProtection": "Pré-visualizar proteção",
  "MoreInformation": "Mais informações",
  "Cart": "Carrinho",
  "Subtotal": "Subtotal",
  "Checkout": "Finalização da compra",
  "DiscountCode": "Código de desconto",
  "Apply": "Aplicar",
  "Shipping": "Envio",
  "Total": "Total",
  "ShippingProtection": "Proteção de envio",
  "Product": "Produto",
  "CopyLink": "Copiar link"
}
